export { default as FlagIcon } from '~icons/lucide/flag';
